import Breadcrumbs from "../Breadcrumbs";

const PageTitle = ({ title, BreadcrumbItems }) => {
  return (
    <>
      {BreadcrumbItems && <Breadcrumbs BreadcrumbItems={BreadcrumbItems} />}

      <h2 className="h4 mt-3 tw-mb-5">{title}</h2>
    </>
  );
};

export default PageTitle;
